var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBundleAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Bundles/AWS@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 29,
    height: 29.1428571
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.4260582%",
    y1: "7.4114724%",
    x2: "37.96962%",
    y2: "103.76182%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0669BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "0 0.055161909 29 0.055161909 23.0670117 4.85714286 6.09289309 4.85714286"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Bundles/AWS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64",
    transform: "translate(0, 4.8571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#35B8ED",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.8333, 6.0714)",
    id: "Microsoft_Azure"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24521694,0.000219682141 L11.7886179,0.000219682141 L6.03402354,17.5939033 C5.9127488,17.964602 5.57586756,18.2142857 5.19670133,18.2142857 L0.88256519,18.2142857 C0.598323497,18.2142857 0.331467924,18.0730729 0.165673388,17.8348343 C-0.000121148591,17.5965957 -0.0445538851,17.2905366 0.0463074546,17.0126244 L5.40768183,0.620602049 C5.52890826,0.249740039 5.86591617,0 6.24521694,0 L6.24521694,0.000219682141 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8203983,11.9830827 L6.06425516,11.9830827 C5.89766316,11.9828975 5.74792971,12.0853427 5.68681065,12.2413242 C5.62569159,12.3973058 5.66563974,12.575043 5.78751099,12.6893599 L11.4140062,17.9750181 C11.5778214,18.1288215 11.7935179,18.2142857 12.0175418,18.2142857 L16.9756098,18.2142857 L14.8203983,11.9830827 Z",
    id: "Path",
    fill: "#0078D4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26755978,0 C5.8822981,-0.00151314954 5.54086653,0.254770116 5.42495321,0.632478888 L0.0519739615,16.9976687 C-0.0453973737,17.2766856 -0.00439024551,17.5869785 0.161862812,17.829176 C0.328115869,18.0713736 0.598752438,18.2150834 0.887101149,18.2142857 L5.32921703,18.2142857 C5.6660399,18.1524155 5.94443029,17.9090273 6.0579232,17.5771968 L7.12939907,14.3309165 L10.9567092,18.0007489 C11.1170948,18.1371292 11.31829,18.2125386 11.5264249,18.2142857 L16.504065,18.2142857 L14.3209383,11.8008081 L7.95683317,11.8023459 L11.8518852,0 L6.26755978,0 Z",
    id: "Path",
    fill: "#EEF6FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7906617,0.619503639 C13.6665909,0.249239033 13.3217033,0 12.9335721,0 L6.60162602,0 C6.98973556,0 7.334588,0.249281308 7.45871565,0.619503639 L12.9538647,17.012185 C13.0470598,17.290148 13.0015618,17.5962889 12.8316372,17.8346146 C12.6617126,18.0729404 12.3881677,18.2142857 12.0967751,18.2142857 L18.4289393,18.2142857 C18.7202935,18.2142857 18.9937733,18.0728403 19.1636469,17.8345254 C19.3335206,17.5962106 19.3789935,17.2901113 19.2858108,17.012185 L13.7906617,0.619503639 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4",
    transform: "translate(14.5, 2.4562) scale(1, -1) translate(-14.5, -2.4562)"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#0078D4",
    transform: "translate(14.5, 2.4562) scale(1, -1) translate(-14.5, -2.4562)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0960AE",
    x: 13.2916667,
    y: 0,
    width: 2.41666667,
    height: 4.85714286
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.2,
    fill: "#000000",
    x: 13.2916667,
    y: 4.85714286,
    width: 2.41666667,
    height: 2.42857143
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundleAzure);
export default __webpack_public_path__ + "static/media/BUNDLE_AZURE.84171b4509afb65ee81c1b2ef9fa55a6.svg";
export { ForwardRef as ReactComponent };